export const CanisterSvg = () => (
    <svg fill="currentColor" height="1em" width="1em" version="1.1" id="Capa_1" viewBox="0 0 60 60">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            {" "}
            <path d="M49.5,13h-1V9h-1.597l0.526-1.794l3.235-1.815c0.395-0.237,0.673-0.614,0.785-1.06c0.112-0.447,0.042-0.911-0.194-1.305 l-1.313-2.188C49.632,0.321,49.065,0,48.463,0c-0.313,0-0.619,0.085-0.866,0.234l-4.712,2.677L40.913,9H38.5v4h-5.356l-3.291-7.24 C28.815,3.476,26.523,2,24.014,2h-8.1C12.377,2,9.5,4.877,9.5,8.414v4.712c-1.723,0.445-3,2.013-3,3.874v39c0,2.206,1.794,4,4,4h39 c2.206,0,4-1.794,4-4V17C53.5,14.794,51.706,13,49.5,13z M40.5,11h5.817H46.5v2h-6V11z M13.5,9.122C13.5,7.4,14.9,6,16.622,6h6.598 c1.275,0,2.41,0.763,2.891,1.943L28.988,15H13.5V9.122z M43.207,48.293l-1.414,1.414L36.086,44H23.914l-5.707,5.707l-1.414-1.414 l5.707-5.707V30.414l-5.707-5.707l1.414-1.414L23.914,29h12.172l5.707-5.707l1.414,1.414L37.5,30.414v12.172L43.207,48.293z"></path>{" "}
        </g>
    </svg>
)

export const SewerSvg = () => (
    <svg fill="currentColor" version="1.1" id="Layer_1" viewBox="0 0 512 512" width="1em" height="1em">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
                {" "}
                <g>
                    {" "}
                    <rect x="91.897" y="39.385" width="65.641" height="288.82"></rect>{" "}
                </g>{" "}
            </g>{" "}
            <g>
                {" "}
                <g>
                    {" "}
                    <rect y="78.769" width="52.513" height="210.051"></rect>{" "}
                </g>{" "}
            </g>{" "}
            <g>
                {" "}
                <g>
                    {" "}
                    <rect x="249.436" y="433.231" width="262.564" height="39.385"></rect>{" "}
                </g>{" "}
            </g>{" "}
            <g>
                {" "}
                <g>
                    {" "}
                    <path d="M196.923,131.601V289.55c54.762,6.055,98.217,49.537,104.275,104.296h157.974 C452.524,252.034,338.735,138.25,196.923,131.601z M253.242,243.915l15.431-36.235c52.485,22.349,93.415,63.688,115.249,116.399 l-36.387,15.071C329.67,296.023,296.183,262.202,253.242,243.915z"></path>{" "}
                </g>{" "}
            </g>{" "}
        </g>
    </svg>
)

export const OthersSvg = () => (
    <svg fill="#ffffffff" width="1em" height="1em" viewBox="-100 -100 1200.00 1200.00">
        <g id="SVGRepo_bgCarrier" stroke-width="0">
            <rect x="-100" y="-100" width="1200px" height="1200px" rx="600" fill="#000000ff" strokewidth="0"></rect>
        </g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path d="M244 416q-35 0-59.5 24.5T160 500t24.5 59.5T244 584t59.5-24.5T328 500t-24.5-59.5T244 416zm256 0q-35 0-59.5 24.5T416 500t24.5 59.5 59 24.5 59.5-24.5 25-59.5-25-59.5-60-24.5h1zm256 0q-35 0-59.5 24.5T672 500t24.5 59.5T756 584t59.5-24.5T840 500t-24.5-59.5T756 416z"></path>
        </g>
    </svg>
)

export const PropaneSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M4 15v3c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-3zm16-2v-3c0-1.86-1.28-3.41-3-3.86V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v3zM9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9z"
        />
    </svg>
)
